import { Component, Input, Output, ElementRef, EventEmitter } from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { NgForm } from '@angular/forms';
import { timezones, findTimezoneKeyFromValue } from '../common-renderers';

@Component({
  selector: 'timezone-picker',
  providers: [
    TranslateService
  ],
  styles: [require('./timezone-picker.scss')],
  template: require('./timezone-picker.html'),
  host: {
    '(document:click)': 'onClick($event)',
  }
})

export class TimezonePicker {
  @Input('timezone') timezone;
  @Input('isVisible') isVisible: boolean;
  @Output('onTimezoneChange') timezoneChanged = new EventEmitter();

  private DEFAULT_TIMEZONE = {key: "(GMT-08:00) Pacific Time (PST)", value: "America/Los_Angeles"};
  private editMode:boolean = false;
  private isSelectionClick:boolean = false;
  private timezoneList;
  private selectedTZ:Object = this.DEFAULT_TIMEZONE;
  private searchValue: string = '';

  constructor(private translate: TranslateService, private elmRef: ElementRef) {
    translate.use(GlobalVariables.LOCALE);
    this.timezoneList = timezones;
  }

  onClick(event) {
    //If click is caused by a timezone selection, close the TZ list
    if(this.isSelectionClick) {
      this.editMode = false;
      this.isSelectionClick = false;
    }
    else {
      //show edit mode if clicked on the component, and close edit mode if clicked outside
      if (this.elmRef.nativeElement.contains(event.target))
        this.editMode = true;
      else
        this.editMode = false;
    }
  }

  //Life Cycle Hooks
  ngOnInit() {
  }

  ngOnChanges(changes) {
    if(changes.timezone) {
      if(changes.timezone.hasOwnProperty('currentValue') && changes.timezone.currentValue) {
        let keyOfTimezone = findTimezoneKeyFromValue(changes.timezone.currentValue);
        if(keyOfTimezone)
          this.selectedTZ = {key: keyOfTimezone, value: changes.timezone.currentValue};
        else
          this.reset();
      }
      else {
        this.reset();
      }
    }

    if(changes.isVisible) {
      if(changes.isVisible.hasOwnProperty('currentValue') && changes.isVisible.currentValue ) {
      }
      else {
        this.reset();
      }
    }
  }

  reset() {
    this.selectedTZ = this.DEFAULT_TIMEZONE;
  }

  emitTimeZoneChange(): void {
    if (this.timezoneChanged) {
      this.timezoneChanged.emit({
        value: this.selectedTZ["value"]
      });
    }
  }

  onTimezoneSelected(tz:Object) {
    this.selectedTZ = tz;
    this.isSelectionClick = true;
    this.emitTimeZoneChange();
  }

  onSearchKey(event:any) {
    this.searchValue = event.target.value;
  }

}


// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-common/timezone-picker/timezone-picker.component.ts